import React, {h, Component} from 'preact'
import {connect} from 'react-redux';
import reduce from '../reducers';
import * as actions from '../actions';
import constants from '../constants'
import Renderer from '../canvas/renderer'
import MultiAlignWidget from './MultiAlignWidget'
import util, {selectMultiple} from "../util";
import GroupBarListItem from "./GroupBarListItem";
import {canDisplayAlign} from "../canvas/component";
import { UnlockOutlined, LockOutlined, DeleteOutlined } from "@ant-design/icons";
import PositionTools from './PositionTools';
import Interactable from '../canvas/interactable';
import store from '../store';

export default @connect(reduce, actions)
class MultiSelectBar extends Component {
  constructor() {
    super();

    this.removeElements = () => {
      Renderer.removeElements(this.props.$elements);
      Interactable.clearMultiinteractable();
    };

    this.toggleLock = () => {
      this.props.$elements.forEach($element => {
        if (util.isLocked($element)) {
          Renderer.unlock($element);
        } else {
          Renderer.lock($element);
        }
      })
    }

    this.copyElements = () => {
      let copies = [];
      this.props.$elements.forEach($element => {
        let $copy = this.copyElement($element);
        copies.push($copy);
      })
      selectMultiple(copies);
    }

    this.copyElement = ($el) => {
      const $copy = Renderer.copy($el);
      return $copy;
    }
  }

  render(props, state) {
    return (
      <div className="context-bar">
        <ul className="secondary">
          <GroupBarListItem {...props} />
          {canDisplayAlign(props.$element) && <li>
            <PositionTools />
          </li>}
          <li>
            <a className="icn rwd-icon hint--bottom" data-hint="Duplicate" onClick={this.copyElements}>
              <span>Copy</span><svg><use xlinkHref={ constants.appPrefix + "/svg/icons.svg#app-copy" }/></svg>
            </a>
          </li>
          <li>
            <a className="icn rwd-icon hint--bottom" data-hint="Lock" onClick={this.toggleLock}>
             <UnlockOutlined />
            </a>
          </li>
          <li>
            <a className="rwd-icon hint--bottom" data-hint="Delete" onClick={this.removeElements}>
              <DeleteOutlined />
            </a>
          </li>
        </ul>
      </div>
    )
  }
}
